import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ProgressBar } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TagModule } from 'primeng/tag';

@Component({
  selector: 'app-custom-progress-bar',
  templateUrl: './custom-progress-bar.component.html',
  styleUrls: ['./custom-progress-bar.component.scss'],
  standalone: true,
  imports: [ProgressBar, ProgressSpinnerModule, CommonModule, TagModule],
})
export class CustomProgressBarComponent {

  @Input() currentValue?: number;
  @Input() finished: boolean = false;
  @Input() heightProgress: string = '0.3rem';
  @Input() hiddenTag: boolean = true;
  @Input() mode: string = 'indeterminate';
  @Input() show: boolean = false;
  @Input() statusMessage: string = 'Inicializando...';
  @Input() totalValue?: number;
  @Input() value?: number;

}
